import { defineComponent as _defineComponent } from 'vue'
import NavigationBreadcrumbs, { breadcrumb } from '../navigation/Breadcrumbs.vue';
import Skeleton from '../loaders/Skeleton.vue';
import { computed } from "vue";
import vuetify from '../../service/useVuetify';



export default /*#__PURE__*/_defineComponent({
  __name: 'PageTitle',
  props: {
    title: { default: '' },
    breadcrumbs: { default: () => [] },
    sticky: { type: Boolean, default: false },
    distanceTop: { type: [Number, Boolean], default: false },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, breadcrumbs: Array<breadcrumb>, sticky: boolean, distanceTop: number | boolean, loading: boolean };



const cssVars = computed(() => {
  return {
  ...(props && props.distanceTop && {'--distance-top': typeof props.distanceTop === "number" ? props.distanceTop : headerHeigth.value + 'px'})
  }
});

const headerHeigth = computed(() => {
  switch (vuetify.value.breakpoint.name) {
    case "sm":
      return 44;
    case "md":
    case "lg":
      return 56;
    case "xl":
      return 64;
    default:
      return 64;
  }
})

return { __sfc: true,props, cssVars, headerHeigth, NavigationBreadcrumbs, Skeleton }
}

})